import './styles.scss';

import React, { useCallback, useContext, useState } from 'react';

import { Navigate } from 'react-router-dom';

import { BubbleSVG } from '../../components/BubbleSVG';
import { FirebaseForm } from '../../components/FirebaseForm';
import { IconRawSvg } from '../../components/IconRawSvg';
import { VisibleOnVersion } from '../../components/VisibleOnVersion';
import { useFirebaseAuth } from '../../hooks';
import { ApiContext } from '../../providers';
import { parseHTML } from '../../services/parseHTML';
import { Storyblok, StoryblokSection } from '../../storyblok';
import { isEmptyObject } from '../../utils';

export const BubbleForm = ({
    sectionData,
}: StoryblokSection<Storyblok.Component.BubbleForm>) => {
    const { setAuthLoading } = useFirebaseAuth();
    const [redirectPath, setRedirectPath] = useState('');
    const { fetchUserScoreData } = useContext(ApiContext);

    const {
        title,
        description,
        formType,
        backgroundImage = '',
        fields,
        buttonLabel,
        successMessage,
    } = sectionData;

    const handleFormSuccess = useCallback(() => {
        setAuthLoading(true);
        setTimeout(() => {
            if (formType === 'firebase_reset_confirmation') {
                setAuthLoading(false);
                setRedirectPath('/login');
                window.location.reload();
            } else {
                fetchUserScoreData()
                    .then((response) => {
                        setAuthLoading(false);
                        if (
                            !response ||
                            !response.scoreData ||
                            isEmptyObject(response.scoreData)
                        ) {
                            setRedirectPath('/check-score');
                        } else {
                            setRedirectPath('/myscore');
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        }, 0);
    }, [setAuthLoading, formType]);

    if (redirectPath) {
        return <Navigate to={redirectPath} />;
    }

    return (
        <div
            className="BubbleForm"
            style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
            }}
        >
            <div className="BubbleForm__component-wrapper">
                {title && (
                    <h2 className="BubbleForm__title">{parseHTML(title)}</h2>
                )}
                {formType && (
                    <>
                        <VisibleOnVersion versions={['upscore']}>
                            <BubbleSVG
                                backgroundSvgName="bubbleTop"
                                centerContentHorizontally
                                centerContentVertically
                            >
                                <FirebaseForm
                                    type={formType}
                                    onFormSuccess={handleFormSuccess}
                                    fields={fields}
                                    buttonLabel={buttonLabel}
                                    successMessage={successMessage}
                                />
                            </BubbleSVG>
                        </VisibleOnVersion>

                        <VisibleOnVersion versions={['pengestyrke']}>
                            <FirebaseForm
                                type={formType}
                                onFormSuccess={handleFormSuccess}
                                fields={fields}
                                buttonLabel={buttonLabel}
                                successMessage={successMessage}
                            />
                        </VisibleOnVersion>
                    </>
                )}
                {description && (
                    <div className="BubbleForm__bottom-section">
                        <p className="BubbleForm__description">
                            {parseHTML(description)}
                        </p>
                        <IconRawSvg
                            className="BubbleForm__arrow"
                            name="upscoreArrow"
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
